<template>
  <div>
    <b-card>
      <b-row>
        <b-col
            cols="12"
            md="6"
        >
          <b-form-group
              label="Başlık"
              label-for="title"
          >
            <b-form-input
                id="title"
                v-model="itemData.title"
                placeholder="Başlık"
            />
          </b-form-group>
        </b-col>
        <b-col
            cols="12"
            md="6"
        >
          <b-form-group
              label="Ürün Grubu"
              label-for="id_product_categories"
          >
            <v-select
                id="id_product_categories"
                v-model="itemData.id_product_categories"
                :options="productGroups"
                label="title"
                :reduce="item => item.id"
                placeholder="Ürün Grubu"
            >
              <template v-slot:option="option">
                <div>
                  {{ option.title }}
                </div>
                <div>
                </div>
              </template>
              <template v-slot:selected-option="option">
                {{ option.title }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col
          cols="12"
      >
        <b-card title="Görsel">
          <b-img
              v-if="itemData.thumb"
              :src="imageUrl + '/media/gallery/' + itemData.thumb"
              thumbnail
              center
          />
          <div class="text-center mt-1">
            <b-button
                variant="primary"
                @click="setModal('gallery')"
            >
              <FeatherIcon icon="UploadIcon" />
              Görsel Yükle
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <cropper-image
        v-if="cropperSettings.type"
        :modal-status="cropperSettings.modalStatus"
        :close-modal="closeModal"
        :file-name="cropperSettings.fileName"
        :folder="cropperSettings.folder"
        :ratio="cropperSettings.ratio"
        @uploadImage="setUploadImage"
    />
    <b-button
        variant="primary"
        :disabled="itemData.submitStatus"
        @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BCol, BFormGroup, BFormInput, BImg, BRow, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

import CropperImage from '@/layouts/components/common/CropperImage.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BImg,
    BButton,
    CropperImage,
    vSelect,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      imageUrl: this.$store.state.app.baseURL,
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      },
    }
  },
  created() {
    this.getProductGroups()
  },
  computed: {
    productGroups() {
      return this.$store.getters['productGroups/dataList']
    },
    itemData() {
      return this.$store.getters['imageGallery/dataItem']
    },
  },
  methods: {
    getProductGroups() {
      this.$store.dispatch('productGroups/getDataList', {
        select: [
          'product_categories.id AS id',
          'product_categories.title AS title',
          'pc.title AS main_group',
        ],
        where: {
          'product_categories.id_product_categories ': null,
        },
      })
    },
    setModal(type) {
      if (type === 'gallery') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'gallery-image.jpg',
          folder: 'gallery',
          ratio: 400 / 300,
          type: 'gallery',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      if (this.cropperSettings.type === 'gallery') {
        this.itemData.filename = item.filename
        this.itemData.thumb = item.thumb
        this.itemData.filename_webp = item.filename_webp
        this.itemData.thumb_webp = item.thumb_webp
      }
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
